<div class="container admin">
    <div class="header">
        <div class="adminHeader">
            <div class="title">User Management</div>
            <div class="addUserButton"><button (click)="OpenAddUserDialog()"> Add User </button></div>
        </div>
        <div class="row">
            <ul class="nav nav-tabs" id="adminTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="admin-tab" data-bs-toggle="tab" data-bs-target="#users"
                        type="button" role="tab" aria-controls="users" aria-selected="true">Existing Users
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <div class="tab-content" id="userTabContext">
        <div class="tab-pane active horizontalTableScroll" id="userTab" role="tabpanel" aria-labelledby="admin-tab">

            <table
              id="tblExisitingUsers"
              mat-table aria-label="Users"
              [dataSource]="dataSource"
              [class.d-none]="isLoadingUsers || users.length == 0">
                <ng-container matColumnDef="userId">
                    <th mat-header-cell *matHeaderCellDef> User ID
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.userID}} </td>
                </ng-container>
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef> First Name
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.firstName }} </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef> Last Name
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
                </ng-container>
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef> Email ID
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.email}} </td>
                </ng-container>

                <ng-container matColumnDef="accessLevel">
                    <th mat-header-cell *matHeaderCellDef> Access Level
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.accessLevel}} </td>
                </ng-container>
                <ng-container matColumnDef="accessId">
                    <th mat-header-cell *matHeaderCellDef> Access ID
                    </th>
                    <td mat-cell *matCellDef="let element"> {{element.accessID}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef> Status
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <span class="status activeStatus" *ngIf="element.status == true">
                            Active
                        </span>
                        <span class="status inactiveStatus" *ngIf="element.status == false">
                            InActive
                        </span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> Action </th>
                    <td mat-cell *matCellDef="let element">
                        <div class="d-flex editDeleteButtons">
                            <button class="icon-button" mat-icon-button (click)="OpenEditUserDialog(element)">
                                <img src="./assets/images/edit.svg" alt="Unable to load image">
                            </button>
                            <!-- <button class="icon-button" mat-icon-button *ngIf="loggedInUser.accessLevel>=5">
                                <img src="./assets/images/trash.svg" alt="Unable to load image">
                            </button> -->
                        </div>
                    </td>
                </ng-container>

                <!--Filters-->
                <ng-container matColumnDef="header-row-first-group">
                    <th class="filterHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="1">

                        <div class="filterSearchbox">
                            <input matInput class="filter-field" [formControl]="userIdFilter" placeholder="Search">
                            <img class="filterIcon" src="assets\images\Icon.jpg" alt="filterIcon">
                        </div>

                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-second-group">
                    <th class="filterHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="1">

                        <div class="filterSearchbox">
                            <input matInput class="filter-field" [formControl]="firstNameFilter" placeholder="Search">
                            <img class="filterIcon" src="assets\images\Icon.jpg" alt="filterIcon">
                        </div>
                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-third-group">
                    <th class="filterHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="1">

                        <div class="filterSearchbox">
                            <input matInput class="filter-field" [formControl]="lastNameFilter" placeholder="Search">
                            <img class="filterIcon" src="assets\images\Icon.jpg" alt="filterIcon">
                        </div>
                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-fourth-group">
                    <th class="filterHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="1">
                        <div class="filterSearchbox">
                            <input matInput class="filter-field" [formControl]="emailFilter" placeholder="Search">
                            <img class="filterIcon" src="assets\images\Icon.jpg" alt="filterIcon">
                        </div>
                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-fifth-group">
                    <th class="filterHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="1">
                        <div class="filterSearchbox">
                            <input matInput class="filter-field" [formControl]="accessLevelFilter" placeholder="Search">
                            <img class="filterIcon" src="assets\images\Icon.jpg" alt="filterIcon">
                        </div>
                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-sixth-group">
                    <th class="filterHeader" mat-header-cell *matHeaderCellDef [attr.colspan]="1">
                        <div class="filterSearchbox">
                            <input matInput class="filter-field" [formControl]="accessIdFilter" placeholder="Search">
                            <img class="filterIcon" src="assets\images\Icon.jpg" alt="filterIcon">
                        </div>
                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-seventh-group">
                    <th class="filterHeader " id="clear" mat-header-cell *matHeaderCellDef [attr.colspan]="1">
                        <a class="clear" (click)="clear()">Clear Filter</a>
                    </th>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-header-row
                    *matHeaderRowDef="['header-row-first-group','header-row-second-group','header-row-third-group',
                       'header-row-fourth-group','header-row-fifth-group','header-row-sixth-group','header-row-seventh-group']"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>


            <div
              *ngIf="dataSource.filteredData.length==0 && showMsg && !isLoadingUsers"
              class="noResult text-center">
              <h5 class="mb-4 text-secondary">No Users Found</h5>
            </div>
            <div
              *ngIf="isLoadingUsers"
              class="mt-2 text-center">
              <div class="spinner-border text-secondary my-3" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <!-- <p class="placeholder-wave">
                <span class="placeholder placeholder-lg bg-secondary col-12" style="height: 40px;"></span>
              </p> -->
            </div>
            <br>
            <!--paginator-->

            <div
              class="row d-flex paginator"
              [class.d-none]="isLoadingUsers || users.length == 0">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4">
                        <mat-form-field class="go-to-select">
                            <mat-label >Go To Page:</mat-label>
                            <mat-select  [(ngModel)]="goTo" (selectionChange)="goToChange()">
                                <mat-option *ngFor="let pageNumber of pageNumbers" [value]="pageNumber">{{pageNumber}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                       </div>
                       <div class="col-lg-4 col-md-4 col-sm-4">

                    </div>
                        <div class="col-lg-4 col-md-4 col-sm-4">
                            <span> Page {{selectedPageNumber}} of {{currenttotalPages}}</span>
                        </div>
                    </div>



                </div>

                <div class="col-lg-6 col-md-6 col-sm-6">


                <mat-paginator #paginator [length]="dataSource.filteredData.length" [pageSize]="10"
                (page)="onPaginateChange($event)"  aria-label="Select page">
            </mat-paginator>
             </div>



            </div>

        </div>
    </div>

</div>

